import { Button } from 'copilot-design-system';
import React from 'react';

import { AlertCircleIcon } from 'src/components/icons';

import StandardPage from './StandardPage';

const params: Parameters<typeof StandardPage>[0] = {
  title: 'Page disabled!',
  titleForClient: 'Page disabled!',
  topIcon: <AlertCircleIcon />,
  descForClient:
    "The page you're trying to reach has been disabled, please get in touch if this is a mistake.",
  desc: "The page you're trying to reach has been disabled by the workspace owner, please get in touch if this is a mistake.",
  actionButton: (
    <Button
      onClick={() => window.location.reload()}
      label="Try Again"
      variant="primary"
    />
  ),
};

export const NotAllowedPage: React.FC = () => <StandardPage {...params} />;
